
export class RequestModel {
    public userId: string;
    public extraVariable: string;
    public date: Date;
    public authToken: string;
    public deviceType: string;
    public hashKey: string;
    public reqObject: any;
    public reqList: any;
    public imageObj: any;
    public imagesList: any;
    public reqArray: any;
    public lattitude: number = 0;
    public longitude: number = 0;
}
